import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
  MatNoDataRow,
} from '@angular/material/table';
import { Invitation } from '@shared/models/invitation.model';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-table-invitations',
  templateUrl: './table-invitations.component.html',
  styleUrl: './table-invitations.component.scss',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatButton,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatNoDataRow,
  ],
})
export class TableInvitationsComponent implements OnChanges {
  @Output() delete: EventEmitter<string> = new EventEmitter();

  @Input({ required: true }) invitations: Invitation[] | undefined;

  protected dataSource: MatTableDataSource<Invitation>;

  protected displayedColumns: string[] = [
    'id',
    'lastName',
    'email',
    'settings',
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.invitations) {
      this.dataSource = new MatTableDataSource<Invitation>(this.invitations);
    }
  }

  deleteInvitation(id: string): void {
    this.delete.emit(id);
  }
}
